<ul class="path">
    <li>
        <a (click)="goTo('root')">Home</a>
        <i *ngIf="ds.path && ds.path.length > 0" class="fa fa-chevron-right"></i>
    </li>

    <li *ngFor="let item of ds.path; let last = last;">
        <a (click)="!last && goTo(item.id)" title="{{ item.name }}">
            {{ item.name }}
        </a>
        <i *ngIf="!last" class="fa fa-chevron-right"></i>
    </li>
</ul>



// WEBPACK FOOTER //
// /app/src/app/views/documents/directory-path/directory-path.component.html